/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isExpireAlert: false,
  isSubcriptionActive: false,
  isPlanExpired: false,
  planExpireDate: "",
  isStudentLimitExceeded: false,
  isSubTutorLimitExceeded: false,
  isStorageLimitExceeded: false,
  triggerChange: false,
};

const checkPlanSlice = createSlice({
  name: "checkPlan",
  initialState,
  reducers: {
    updateCheckPlanState(state, action) {
      state.isExpireAlert = action.payload.isExpireAlert;
      state.isSubcriptionActive = action.payload.isSubcriptionActive;
      state.isPlanExpired = action.payload.isPlanExpired;
      state.planExpireDate = action.payload.planExpireDate;
      state.isStudentLimitExceeded = action.payload.isStudentLimitExceeded;
      state.isSubTutorLimitExceeded = action.payload.isSubTutorLimitExceeded;
      state.isStorageLimitExceeded = action.payload.isStorageLimitExceeded;
    },
    triggerChange(state) {
      state.triggerChange = !state.triggerChange;
    },
    updateIsSubTutorLimitExceeded(state, action) {
      state.isSubTutorLimitExceeded = action.payload;
    },
    updateIsStudentLimitExceeded(state, action) {
      state.isStudentLimitExceeded = action.payload;
    },
  },
});

export const checkPlanSelector = (state) => state.checkPlan;

export const checkPlanActions = checkPlanSlice.actions;

export default checkPlanSlice.reducer;
